import { ImageCachePathDimensions, ImageCachePaths } from '@synergy/models';
import urlJoin from 'url-join';

import { getDynamicImageCachePath } from './get-dynamic-image-cache-path';

// TODO: remove after Arjan has added the full image path
export const getImageUrlByCachePath = (
    apiBaseUrl: string,
    cachePath: ImageCachePathDimensions,
    imageCachePaths?: ImageCachePaths,
    path?: string
) => {
    if (!path) {
        return undefined;
    }

    const imageCachePath = imageCachePaths?.[cachePath];

    if (imageCachePath) {
        return urlJoin(apiBaseUrl, imageCachePath, path);
    }

    return getDynamicImageCachePath(apiBaseUrl, cachePath, path);
};
